import styled from 'styled-components';

type IconActionsProps = {
  title: string;
  color?: 'normal' | 'error';
};

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
export const ItemAttachment = styled.div`
  width: 100%;
  height: 3rem;
  display: flex !important;
  align-items: center;
  gap: 0.2rem;

  p {
    margin: 0 !important;
    max-width: 10rem;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  img {
    width: 1.4rem;
    height: 100%;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    flex: 1;
    margin-right: 0.2rem;
  }
`;

export const WrapperIcon = styled.div<IconActionsProps>`
  .Icons {
    position: relative;
    padding: 0.3rem;
    background: transparent;
    height: 2rem;
    width: 2rem;
    &:hover {
      background: ${({ theme, color }) =>
        color === 'error' ? theme.colors.error_200 : theme.colors.tertiary_300};
      opacity: 1;
      &::after {
        content: '${({ title }) => title}';
        position: absolute;
        bottom: -0.5rem;
        font-size: 0.5rem;
        color: ${({ theme, color }) =>
          color === 'error' ? theme.colors.error : theme.colors.tertiary_500};
      }
    }
    .ImgView {
      width: 1.2rem;
    }
    .ImgImport {
      height: 0.9rem;
    }
  }
`;
